module.exports = __webpack_public_path__ + "img/discord.d8387a85.svg";